import { connect } from "react-redux"
import NavMenu from "./Nav-Menu"

const mapStateToProps = (state) => {
    let navMenu = state.navMenu.current.items
    return {
        items: navMenu,
        user: state.auth.authUser

    }
}
const mapDispatchToProps = (dispatch) => {

    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavMenu)
